import { pharmaciesRouteStore } from '../domain/store';
import { pharmacyUpsertModalRouteStore } from '../components/pharmacy-upsert-modal/domain/store';

export default () => {
  pharmacyUpsertModalRouteStore.setInitialState();
  pharmaciesRouteStore.setValue('activePharmacyId', null);
  pharmaciesRouteStore.setValue('showingPharmacyUpsertModal', false);
};
